import * as React from "react";
import { theme } from "../../../theme";

interface Props {
  color?: string;
}

export const PackageSearchIcon: React.FC<Props> = ({
  color = theme.colors.text,
}) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.66602 5.5V9.5C1.66602 12.0141 1.66602 13.2713 2.44706 14.0523C3.22812 14.8333 4.48519 14.8333 6.99935 14.8333H8.66602M14.3327 9.16667V5.5"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.57874 4.04242L1.66602 5.49935H14.3327L13.4979 4.10804C12.9287 3.15949 12.6442 2.68522 12.1857 2.42562C11.7272 2.16602 11.1741 2.16602 10.0679 2.16602H5.96849C4.886 2.16602 4.34476 2.16602 3.89277 2.41622C3.44078 2.66642 3.15344 3.12509 2.57874 4.04242Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 5.49935V2.16602"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.66602 7.5H9.33268"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.2526 14.7526L13.0001 13.5002M13.0001 13.5002C13.3621 13.1383 13.5859 12.6383 13.5859 12.0859C13.5859 10.9814 12.6905 10.0859 11.5859 10.0859C10.4813 10.0859 9.58594 10.9814 9.58594 12.0859C9.58594 13.1905 10.4813 14.0859 11.5859 14.0859C12.1382 14.0859 12.6382 13.8621 13.0001 13.5002Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
